module.exports = {
      id: "spotify-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#spotify",
      toString: function () {
        return this.url;
      }
    }